export default __webpack_public_path__ + "static/media/transfacil_galery_13.a3118267.jpg";